import { render } from "./Flip.vue?vue&type=template&id=01c50028&scoped=true"
import script from "./Flip.vue?vue&type=script&lang=js"
export * from "./Flip.vue?vue&type=script&lang=js"

import "./Flip.vue?vue&type=style&index=0&id=01c50028&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01c50028"]])

export default __exports__